module.exports = __webpack_public_path__ + "media/dm-tyk-intro.10efa3be.mp4";